import { beastModeOptions } from '@gonfalon/dogfood-flags/dogfood-flags';

import { getExpiration } from './expiration';

export type BeastModePermission =
  | 'internal.delete.account'
  | 'internal.patch.profile'
  | 'internal.post.account.owner'
  | 'internal.post.mfa.disable';

export function shouldRefreshBeastMode(routeName: BeastModePermission) {
  // check if beast mode is expired
  if (getExpiration() >= new Date().getTime()) {
    return false;
  }
  const options = beastModeOptions();
  return options.all || options.routes.includes(routeName);
}
